import React, { useMemo } from "react";

type iProps = {
    children: any,
    clickable?: boolean,
    onPressFunc?: () => void
    customBaseCardStyle?: string
}

const BaseCard : React.FC<iProps> = ({ children, clickable, onPressFunc, customBaseCardStyle }) => {

    const handleClick=() => {
        if(clickable && onPressFunc){
            onPressFunc()
        }else {
            return
        }
    }

    return (
        <div className={`base-card ${customBaseCardStyle ? customBaseCardStyle : ''} ${clickable ? 'cursor-pointer' : ''}`} onClick={handleClick}>
            {children}
        </div>
    )
}

export default BaseCard;